import { AppTheme } from '@meitu/saas-ui/es/theme';
import { getLocaleStore } from '@/i18n';
import { IEnhanceSlider } from '../types';
import contrastDarkWrapBackgroundImage from './assets/dark/contrast-bg.jpg';
import contrastDarkBackgroundImage from './assets/dark/contrast.jpg';
import structureDarkWrapBackgroundImage from './assets/dark/structure-bg.jpg';
import structureDarkBackgroundImage from './assets/dark/structure.jpg';
import contrastLightWrapBackgroundImage from './assets/light/contrast-bg.jpg';
import contrastLightBackgroundImage from './assets/light/contrast.jpg';
import structureLightWrapBackgroundImage from './assets/light/structure-bg.jpg';
import structureLightBackgroundImage from './assets/light/structure.jpg';

export const getSliderConfig = (theme = AppTheme.white) => {
    const { $t } = getLocaleStore();

    return [
        {
            featureType: 'light',
            name: $t((v) => v.mainLayer.enhance.config.smartLightAlpha),
            keyName: 'smartLightAlpha',
            maxVal: 100,
            minVal: -100,
            lightBackgroundClass: 'brt_1',
            lightWrapBackgroundClass: 'brt_2',
            darkBackgroundClass: 'brt_1',
            darkWrapBackgroundClass: 'brt_2',
        },
        {
            featureType: 'light',
            name: $t((v) => v.mainLayer.enhance.config.light),
            keyName: 'brightness',
            maxVal: 100,
            minVal: -100,
            lightBackgroundClass: 'ld_1',
            lightWrapBackgroundClass: 'ld_2',
            darkBackgroundClass: 'ld_1',
            darkWrapBackgroundClass: 'ld_2',
        },
        {
            featureType: 'light',
            name: $t((v) => v.mainLayer.enhance.config.contrast),
            keyName: 'contrast',
            maxVal: 100,
            minVal: -100,
            lightBackgroundImage: contrastLightBackgroundImage,
            lightWrapBackgroundImage: contrastLightWrapBackgroundImage,
            darkBackgroundImage: contrastDarkBackgroundImage,
            darkWrapBackgroundImage: contrastDarkWrapBackgroundImage,
        },
        {
            featureType: 'color',
            name: $t((v) => v.mainLayer.enhance.config.saturation),
            keyName: 'saturation',
            maxVal: 100,
            minVal: -100,
            opacityOpposite: true,
            lightBackgroundClass: 'bhd_1',
            lightWrapBackgroundClass: 'bhd_2',
            darkBackgroundClass: 'bhd_1',
            darkWrapBackgroundClass: 'bhd_2',
        },
        {
            featureType: 'particulars',
            name: $t((v) => v.mainLayer.enhance.config.structure),
            keyName: 'structure',
            maxVal: 100,
            minVal: -100,
            lightBackgroundImage: structureLightBackgroundImage,
            lightWrapBackgroundImage: structureLightWrapBackgroundImage,
            darkBackgroundImage: structureDarkBackgroundImage,
            darkWrapBackgroundImage: structureDarkWrapBackgroundImage,
        },
        {
            featureType: 'particulars',
            name: $t((v) => v.mainLayer.enhance.config.sharpen),
            keyName: 'sharpen',
            maxVal: 100,
            minVal: 0,
            lightBackgroundClass: 'brt_1',
            lightWrapBackgroundClass: 'brt_2',
            darkBackgroundClass: 'brt_1',
            darkWrapBackgroundClass: 'brt_2',
        },
    ].map((item: IEnhanceSlider) => {
        theme = theme === AppTheme.dark ? AppTheme.dark : AppTheme.white;
        //底层背景
        item.background =
            theme == 'dark'
                ? item.darkBackgroundClass
                    ? { useStyle: true, classname: item.darkBackgroundClass }
                    : item.darkBackgroundImage
                : item.lightBackgroundClass
                  ? { useStyle: true, classname: item.lightBackgroundClass }
                  : item.lightBackgroundImage;

        //蒙版背景
        item.wrapBackground =
            theme == 'dark'
                ? item.darkWrapBackgroundClass
                    ? { useStyle: true, classname: item.darkWrapBackgroundClass }
                    : item.darkWrapBackgroundImage
                : item.lightWrapBackgroundClass
                  ? { useStyle: true, classname: item.lightWrapBackgroundClass }
                  : item.lightWrapBackgroundImage;
        return item;
    });
};
